<template>
  <section class="app-docs">
    <CommonContainer class="app-docs-container">
      <LayoutAside class="app-docs-side" :class="openMenu && 'is__active'" @touch.prevent>
        <div class="app-docs-side-inner">
          <GfrButton class="app-docs-menu-btn" @click="closeDocumentMenu">
            <svg class="app-docs-menu-icon" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 3.81441L0 0H4.65638L26 20.0189L21.6361 24.1131L0 3.81441Z" fill="#FFBA00" />
              <path
                d="M17.3012 28.164L4.68543 40H0.00611383L0.00611383 36.234L12.9545 24.0914L17.3012 28.164Z"
                fill="#FFBA00"
              />
            </svg>
          </GfrButton>
          <div class="app-docs-top">
            <div class="app-docs-search">
              <input
                ref="inputRef"
                v-model="inputValue"
                class="app-docs-search-input"
                :placeholder="formatTransify('UGC_OFFICIAL_WEBSITE_FILTER_TEXT')"
                @input="searching = false"
              />
              <svg
                v-show="!searching"
                class="app-docs-search-icon"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="searchTrigger"
              >
                <path
                  class="app-docs-search-path"
                  d="M9 15L7.02929 13.0293C7.01054 13.0105 7 12.9851 7 12.9586V7.53401C7 7.51196 6.99271 7.49052 6.97926 7.47304L2 1H16L10.5237 7.47204C10.5084 7.49009 10.5 7.51298 10.5 7.53663V17"
                  stroke="#7A7E85"
                  stroke-width="1.5"
                />
                <rect class="app-docs-search-rect" x="13" y="7.5" width="5" height="1.5" fill="#7A7E85" />
                <rect class="app-docs-search-rect" x="13" y="10.5" width="5" height="1.5" fill="#7A7E85" />
                <rect class="app-docs-search-rect" x="13" y="13.5" width="5" height="1.5" fill="#7A7E85" />
              </svg>
              <svg
                v-show="searching"
                class="app-docs-search-clear"
                viewBox="0 0 17 17"
                xmlns="http://www.w3.org/2000/svg"
                @click="clearSearchValue"
              >
                <path
                  d="M1.15906 0L0 1.15907L7.34094 8.50001L0.386688 15.4543L1.54575 16.6133L8.5 9.65907L15.4543 16.6133L16.6133 15.4543L9.65906 8.50001L17 1.15907L15.8409 0L8.5 7.34094L1.15906 0Z"
                />
              </svg>
            </div>
            <GfrButton
              class="app-docs-obsolete-btn"
              :data-title="
                showObsolete
                  ? formatTransify('UGC_OFFICIAL_WEBSITE_OBSOLETE_TIPS1')
                  : formatTransify('UGC_OFFICIAL_WEBSITE_OBSOLETE_TIPS2')
              "
              @click="viewObsolete"
            >
              <svg
                v-show="showObsolete"
                class="app-docs-obsolete-sight"
                viewBox="0 0 22 15"
                fill="#7A7E85"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.9965 7.65585C21.9993 7.2215 21.8112 6.90207 21.8007 6.88954C20.3106 4.25334 17.5341 2.56132 17.4186 2.49274C15.4287 1.27986 13.2674 0.662618 11.0039 0.65886V0.645081C8.73518 0.648839 6.57637 1.26452 4.58403 2.48021C4.47131 2.5488 1.68957 4.24081 0.204656 6.87577C0.193847 6.88954 0.00329124 7.20803 0.00607082 7.64207H0.00329124C-0.00226791 8.07988 0.191376 8.40212 0.201877 8.41465C1.68926 11.0509 4.46853 12.7429 4.58125 12.8111C6.57359 14.0259 8.7324 14.6406 10.9987 14.6456V14.6582C13.2674 14.6557 15.429 14.0387 17.4214 12.8237C17.5369 12.7551 20.313 11.0634 21.8035 8.42843C21.8143 8.41465 22.0049 8.09366 21.9993 7.65585H21.9965ZM11.0323 13.0031C7.84262 13.0031 5.257 10.6071 5.257 7.65116C5.257 4.69521 7.84262 2.29921 11.0323 2.29921C14.2221 2.29921 16.8077 4.69521 16.8077 7.65116C16.8077 10.6071 14.2221 13.0031 11.0323 13.0031Z"
                />
                <path
                  d="M11.001 10.9716C12.9796 10.9716 14.5836 9.4853 14.5836 7.65181C14.5836 5.81831 12.9796 4.33197 11.001 4.33197C9.02243 4.33197 7.41846 5.81831 7.41846 7.65181C7.41846 9.4853 9.02243 10.9716 11.001 10.9716Z"
                />
              </svg>
              <svg
                v-show="!showObsolete"
                class="app-docs-obsolete-out-sight"
                viewBox="0 0 22 16"
                fill="#7A7E85"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.75161 5.03833C7.93812 5.64681 7.41772 6.57846 7.41772 7.62255C7.41772 9.45612 9.02154 10.9424 11.0003 10.9424C12.3277 10.9424 13.4865 10.2735 14.1054 9.27949L8.75161 5.03833Z"
                />
                <path
                  d="M14.5631 7.97294C14.5761 7.8577 14.5829 7.74089 14.5829 7.62251C14.5829 5.78894 12.9791 4.30267 11.0003 4.30267C10.6794 4.30267 10.3684 4.34213 10.0723 4.41541L14.5628 7.97294H14.5631Z"
                />
                <path
                  d="M15.8091 10.6292C14.7699 12.0441 13.0178 12.9735 11.0314 12.9735C7.84165 12.9735 5.25602 10.5775 5.25602 7.62157C5.25602 6.08113 5.95864 4.69256 7.08313 3.71612L5.10469 2.14874C4.92958 2.24488 4.7557 2.34541 4.58306 2.45094C4.47033 2.51953 1.68859 4.21155 0.20368 6.8465C0.19287 6.86028 0.00231468 7.17876 0.00509426 7.6128H0.00231468C-0.00324447 8.05061 0.190399 8.37285 0.2009 8.38538C1.68828 11.0216 4.46755 12.7136 4.58028 12.7819C6.57262 13.9966 8.73142 14.6114 10.9977 14.6164V14.6289C13.2665 14.6264 15.428 14.0095 17.4204 12.7944C17.4519 12.7756 17.6823 12.6356 18.0303 12.3885L15.8091 10.6289V10.6292Z"
                />
                <path
                  d="M6.41821 1.52062L8.21876 2.94708C9.05109 2.51617 10.0104 2.27002 11.0317 2.27002C14.2214 2.27002 16.807 4.66603 16.807 7.62197C16.807 8.27179 16.682 8.89435 16.4531 9.47057L19.0931 11.5622C19.9884 10.8012 21.0564 9.7186 21.8026 8.39956C21.8134 8.38578 22.0039 8.06479 21.9984 7.62698H21.9956C21.9984 7.19263 21.8103 6.8732 21.7998 6.86067C20.3096 4.22447 17.5331 2.53245 17.4176 2.46387C15.4277 1.25099 13.2665 0.633748 11.003 0.62999V0.616211C9.41429 0.618716 7.87965 0.921858 6.41821 1.52062Z"
                />
                <path d="M2.39796 -0.000446695L1.59937 1.03601L19.6088 15.3034L20.4074 14.2669L2.39796 -0.000446695Z" />
              </svg>
            </GfrButton>
          </div>
          <div class="app-docs-tabs">
            <div
              v-for="(tab, index) in tabsData"
              :key="index"
              :class="['app-docs-tab', tabIndex === index && 'active']"
              @click="toggleTab(index)"
            >
              {{ formatTransify(tab.name) }}
            </div>
          </div>
          <div v-show="searching" class="app-docs-search-result" v-html="formatSearchTip"></div>
          <keep-alive>
            <div ref="catalogWrapper" class="app-docs-catalogs-wrapper">
              <LazyCommonCatalogs
                ref="catalog"
                :url="String($route.params.id)"
                :data="currentData"
                :class="['app-docs-catalogs', mounted && 'visible']"
              />
            </div>
          </keep-alive>
        </div>
      </LayoutAside>
      <LayoutMain class="app-docs-main">
        <NuxtPage :next="nextDocument" :pre="prevDocument" />
      </LayoutMain>
    </CommonContainer>
  </section>
</template>
<script lang="ts" setup>
import type { CatalogsConfig } from '~/stores/document'
interface DocumentCategory {
  name: string
  base: 'module' | 'type'
}

useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-index-page-cache-tag'])
})
const { formatTransify } = useStore()
const documentStore = useDocumentStore()
const { fetchCategoryList, fetchModuleList, closeDocumentMenu } = documentStore
const { moduleData, typeData, moduleActiveData, typeActiveData, openMenu } = storeToRefs(documentStore)
await fetchModuleList()
await fetchCategoryList()

const route = useRoute()
const catalogWrapper = ref<any>()
const catalog = ref<any>()
const nextDocument = ref<CatalogsConfig | null>(null)
const prevDocument = ref<CatalogsConfig | null>(null)

const inputRef = ref<HTMLInputElement>()
const inputValue = ref<string>('')
const searching = ref<boolean>(false)
const searchData = ref<CatalogsConfig[]>([])
const showObsolete = ref<boolean>(false)
const tabIndex = ref(-1)
const tabsData = ref<DocumentCategory[]>([
  {
    name: 'UGC_OFFICIAL_WEBSITE_MODULES',
    base: 'module'
  },
  {
    name: 'UGC_OFFICIAL_WEBSITE_TYPE',
    base: 'type'
  }
])
// 根据是否展示废弃文章以及Tab切换获取指定的数据
const currentData = computed(() => {
  let data: CatalogsConfig[]
  if (tabIndex.value === -1) return []
  if (showObsolete.value) {
    data = tabIndex.value === 0 ? moduleData.value : typeData.value
  } else {
    data = tabIndex.value === 0 ? moduleActiveData.value : typeActiveData.value
  }
  if (searching.value) {
    data = search(data)
  }
  return data
})
const findFirstArticle = (arr: CatalogsConfig[], key = 'url'): CatalogsConfig | undefined => {
  for (const item of arr) {
    if (item[key as keyof CatalogsConfig]) {
      return item
    } else if (item.children) {
      return findFirstArticle(item.children, key)
    }
  }
  return undefined
}
const flatDocuments = (arr: CatalogsConfig[], key: keyof CatalogsConfig) => {
  const newArr: CatalogsConfig[] = []
  arr.forEach((item) => {
    if (item[key]) {
      newArr.push(item)
    }
    if (item.children) {
      newArr.push(...flatDocuments(item.children, key))
    }
  })
  return newArr
}
const firstTypeArticle = computed(() => {
  return findFirstArticle(typeData.value)
})
/* no route.params.id, navigate to first document of current category */
if (!route.params.id) {
  firstTypeArticle.value?.url && navigateTo(`/${route.params.lang}/docs/${firstTypeArticle.value?.url}`)
}
const updateActivePath = (arr: CatalogsConfig[], key: string, value: number | string, tab = 0) => {
  const path: CatalogsConfig[] = []
  const found = arr.some(function find(item: CatalogsConfig) {
    if (item[key as keyof CatalogsConfig] === value || (item.children && item.children.some(find))) {
      path.push(item)
    }
    return item[key as keyof CatalogsConfig] === value || (item.children && item.children.some(find))
  })
  if (found) {
    tabIndex.value = tab
    path.forEach((item) => {
      item.open = true
    })
  }
  return path
}

const findDocument = (
  arr: CatalogsConfig[],
  key: keyof CatalogsConfig,
  value: string,
  type: 'next' | 'pre'
): CatalogsConfig | null => {
  const index = arr.findIndex((item) => item[key] === value)
  return type === 'next' ? arr[index + 1] || null : arr[index - 1] || null
}
const allDocuments = computed(() => {
  return flatDocuments(currentData.value, 'url')
})
const setDocument = (documents = allDocuments.value) => {
  nextDocument.value = !searching.value ? findDocument(documents, 'url', String(route.params.id), 'next') : null
  prevDocument.value = !searching.value ? findDocument(documents, 'url', String(route.params.id), 'pre') : null
}
const filterData = (arr: CatalogsConfig[], key: keyof CatalogsConfig) => {
  arr.forEach((item) => {
    if (String(item[key]).toLowerCase().includes(inputValue.value.toLowerCase()) && item.url) {
      const newItem = { ...item, children: [] }
      searchData.value.push(newItem)
    }
    if (item.children) {
      filterData(item.children, key)
    }
  })
}
const clearSearchValue = () => {
  inputValue.value = ''
  searching.value = false
  searchData.value = []
  setDocument()
}
const searchTrigger = () => {
  if (inputValue.value.trim() === '') {
    return
  }
  searching.value = true
  nextDocument.value = null
  prevDocument.value = null
}
const search = (data: CatalogsConfig[]) => {
  searchData.value = []
  filterData(data, 'title')
  return searchData.value
}
const formatSearchTip = computed(() => {
  return formatTransify('UGC_OFFICIAL_WEBSITE_SEARCHED').replace(
    '{num}',
    `<span style="color: #fff">${searchData.value.length.toString()}</span>`
  )
})

const toggleTab = (index: number) => {
  if (index === tabIndex.value) return false
  tabIndex.value = index
}
const viewObsolete = () => {
  showObsolete.value = !showObsolete.value
  storage.setItem('showObsolete', showObsolete.value)
}
watch(
  () => inputValue.value,
  (value) => {
    if (value.trim() === '') {
      clearSearchValue()
    }
  }
)
watch(
  () => tabIndex.value,
  async () => {
    await nextTick()
    catalogWrapper.value && (catalogWrapper.value.scrollTop = 0)
  }
)
watch(
  () => showObsolete.value,
  () => {
    setDocument()
  }
)
/* --- init --- */
const mounted = ref(false)
const init = (value: string = String(route.params.id)) => {
  updateActivePath(moduleData.value, 'url', value, 0)
  updateActivePath(typeData.value, 'url', value, 1)
  setDocument()
}
watch(
  () => route.params.id,
  (value) => {
    if (!value) {
      firstTypeArticle.value?.url && navigateTo(`/${route.params.lang}/docs/${firstTypeArticle.value?.url}`)
    }
    closeDocumentMenu()
    init(String(value))
  }
)
watch(
  () => openMenu.value,
  (val) => {
    if (!val) {
      document.body.classList.remove('ban-scroll')
    } else {
      document.body.classList.add('ban-scroll')
    }
  }
)
onMounted(() => {
  init()
  mounted.value = true
  showObsolete.value = storage.getItem('showObsolete')
  inputRef.value?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      searchTrigger()
    }
  })
})
</script>
<style lang="scss" scoped>
.app-docs-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.app-docs-obsolete-sight {
  width: 22px;
  height: 15px;
  transition: fill 0.3s;
}
.app-docs-obsolete-out-sight {
  width: 22px;
  height: 16px;
  transition: fill 0.3s;
  margin-top: 1px;
}
.app-docs-obsolete-btn {
  position: relative;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background-color: #363a41;
  border: 1px solid #4d5158;
  margin-left: 16px;
  border-radius: 0;
  &::after {
    content: attr(data-title);
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 99;
    max-width: 300px;
    min-width: 150px;
    color: #363a41;
    background-color: #d2d2d2;
    opacity: 0;
    transform: translateY(30%);
    font-size: 13px;
    padding: 4px 10px;
    transition: 0.3s;
    pointer-events: none;
  }
}
.app-docs-menu-btn {
  display: none;
}
.app-docs {
  width: 100%;
  position: relative;
  display: flex;
  background-image: url('@/assets/images/tutorial_texture.jpg');
  background-size: 100% auto;
  background-position: center top;
  background-repeat: repeat-y;
}
.app-docs-container {
  display: flex;
}

.app-docs-side {
  position: relative;
  z-index: 1;
  padding: 120px 30px 40px 0;
  &:after {
    content: '';
    position: absolute;
    z-index: -1;
    right: 0;
    top: 0;
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.12);
  }
}
.app-docs-side-inner {
  position: sticky;
  top: 120px;
  bottom: 0;
  width: 340px;
  max-height: calc(100vh - 120px);
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.app-docs-catalogs-wrapper {
  width: 100%;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #4d5158;
    border-radius: 0;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
.app-docs-catalogs {
  width: 100%;
  opacity: 0;
  transition: 0.3s;
  &.visible {
    opacity: 1;
  }
}
.app-docs-main {
  flex: 1;
}
/* --- Search --- */
.app-docs-search {
  position: relative;
  flex: 1;
}
.app-docs-search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  cursor: pointer;
  //fill: #7a7e85;
  .app-docs-search-rect,
  .app-docs-search-path {
    transition: 0.2s;
  }
  &:hover {
    .app-docs-search-path {
      stroke: #fff;
    }
    .app-docs-search-rect {
      fill: #fff;
    }
  }
}
.app-docs-search-input {
  width: 100%;
  height: 40px;
  padding: 8px 34px 8px 14px;
  background-color: #363a41;
  border: 1px solid #4d5158;
  color: #fff;
  transition: 0.3s;
  border-radius: 0;
  &:focus {
    border-color: #c8ccd3;
  }
}
.app-docs-search-clear {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  width: 17px;
  height: 17px;
  cursor: pointer;
  fill: #7a7e85;
  transition: 0.3s;
  &:hover {
    fill: #fff;
  }
}
/* --- Tabs --- */
.app-docs-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: #c8ccd3;
  margin-bottom: 15px;
}
.app-docs-tab {
  flex: 1;
  width: 170px;
  height: 40px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #363a41;
  cursor: pointer;
  transition: 0.3s;
  &.active {
    color: #000;
    background-color: #ffba00;
  }
}
.app-docs-search-result {
  font-size: 18px;
  line-height: 22px;
  color: #c8ccd3;
  margin-bottom: 10px;
}
.app-docs-search-result-text {
  color: #fff;
}
@media not all and (hover: none) {
  .app-docs-obsolete-btn {
    &:hover {
      .app-docs-obsolete-sight,
      .app-docs-obsolete-out-sight {
        fill: #fff;
      }
      &::after {
        opacity: 1;
        transform: translateY(0%);
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .app-docs {
    //padding-top: 80px;
    min-height: calc(100vh - 80px);
  }
}
@media not all and (min-width: 1024px) {
  .app-docs-side {
    position: fixed;
    top: 120px;
    left: 0;
    z-index: 90;
    transform: translateX(-100%);
    transition: 0.3s;
    width: 100%;
    height: calc(100% - 120px);
    background-color: rgba(0, 0, 0, 0.9);
    padding: 40px 32px;
    opacity: 0;
    &:after {
      display: none;
    }
    &.is__active {
      opacity: 1;
      transform: translateX(0);
    }
  }
  .app-docs-side-inner {
    position: relative;
    top: 0;
    width: 686px;
    max-height: 100%;
    padding-bottom: 0;
  }
  .app-docs-top {
    margin-bottom: 30px;
  }
  .app-docs-search {
    width: 594px;
    font-size: 28px;
    line-height: 38px;
    margin-left: 92px;
  }
  .app-docs-search-input {
    height: 72px;
    padding: 10px 50px 10px 20px;
  }
  .app-docs-obsolete-btn {
    width: 72px;
    height: 72px;
    .app-docs-obsolete-sight {
      width: 40px;
      height: 25px;
    }
    .app-docs-obsolete-out-sight {
      width: 40px;
      height: 27px;
    }
  }
  .app-docs-search-icon {
    width: 36px;
    height: 36px;
    right: 16px;
  }
  .app-docs-search-clear {
    width: 28px;
    height: 28px;
    right: 18px;
  }
  .app-docs-tabs {
    margin-bottom: 30px;
  }
  .app-docs-tab {
    height: 60px;
    font-size: 32px;
  }
  .app-docs-menu-btn {
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    width: 72px;
    height: 72px;
    border-radius: 0;
    background: linear-gradient(135deg, #131313 calc(100% - 0.625rem), transparent 0.625rem);
  }
  .app-docs-menu-icon {
    width: 26px;
    height: 40px;
    transform: rotate(180deg);
  }
  .app-docs-search-result {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 26px;
  }
  @media screen and (orientation: portrait) {
    .app-docs {
      background-image: url('@/assets/images/patch-note-mobile.jpg');
    }
  }
  @media screen and (orientation: landscape) {
    .app-docs-side-inner {
      width: 100%;
    }
    .app-docs-search {
      width: 92.5%;
    }
  }
}
</style>
